import { render, staticRenderFns } from "./LaudoTecnicoReport.vue?vue&type=template&id=21c4f5bb&scoped=true"
import script from "./LaudoTecnicoReport.vue?vue&type=script&lang=js"
export * from "./LaudoTecnicoReport.vue?vue&type=script&lang=js"
import style0 from "./LaudoTecnicoReport.vue?vue&type=style&index=0&id=21c4f5bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c4f5bb",
  null
  
)

export default component.exports